import type { ReactNode } from 'react';
import { OkSolIkon } from './ikon';

/**
 * PAYLAŞILAN DÜĞMELER.
 *
 * Neden tek yerde: aynı işlev 12 ekranda ayrı ayrı yazılmıştı ve her biri biraz
 * farklı görünüyordu — geri linki bir yerde altı çizili yazı, başka yerde düz
 * metindi. Altı çizili yazı bu tasarım dilinde bir şeye karşılık gelmiyor:
 * ekranın geri kalanı kart, rozet ve düğmelerden oluşuyor.
 *
 * ⚠️ HER İKİNCİL EYLEM DÜĞMEYE ÇEVRİLMEZ. Bilinçli olarak link kalanlar:
 *    - K5 izin override ("İzni alamadım, yine de başlıyorum") — kazara
 *      basılmaması için düğme DEĞİL, altta duran link olmalı.
 *    - Rutin kontroldeki "geç" — "tamam" ile görsel olarak yarışmamalı.
 *    Bunları düğmeye çevirmek belgelenmiş bir kararı bozar.
 */

/** Geri navigasyonu — sayfa başında duran, ikonlu, çerçeveli düğme. */
export function GeriDugme({ etiket, onClick }: { etiket: string; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="mb-3 inline-flex items-center gap-1.5 rounded-(--radius-mod) border border-line bg-surface px-3 py-1.5 text-sm font-medium text-ink-2 shadow-(--shadow-mod) hover:border-navy-line hover:bg-navy-bg hover:text-navy"
    >
      <OkSolIkon boyut={15} />
      {etiket}
    </button>
  );
}

/**
 * İkincil eylem — "Vazgeç", "Düzenle", "Kapat" gibi.
 * Çerçevesiz ama düğme gövdesi var: tıklanabilir alanı belli, altı çizili değil.
 */
export function SessizDugme({
  children,
  onClick,
  disabled,
  renk = 'notr',
}: {
  children: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  renk?: 'notr' | 'navy' | 'crit';
}) {
  const t =
    renk === 'navy'
      ? 'text-navy hover:bg-navy-bg'
      : renk === 'crit'
        ? 'text-crit hover:bg-crit-bg'
        : 'text-muted hover:bg-surface-2 hover:text-ink';
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`rounded-(--radius-mod) px-2.5 py-1.5 text-sm font-medium disabled:opacity-40 ${t}`}
    >
      {children}
    </button>
  );
}
